const prodConfig = {
  apiKey: "rzp_live_iJcBvpNpCc9E6F",
  secret: "2XSdbKV7zmdQUfufxMACNq99",
};
const devConfig = {
  apiKey: "rzp_test_KWSehuno9ktquq",
  secret: "EshQ5vxraoRivGRxotgijVXM",
};
export const config =
  process.env.NODE_ENV === "production" &&
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1"
    ? prodConfig
    : devConfig;
